import cx from 'classnames'

export const Button = (props) => {

    const { className, type, loading, loadingText, onClick, style } = props

    return (
        <button type={type} className={className} disabled={loading} onClick={onClick} style={style}>
            <span className={cx('indicator-label', loading && 'd-none')}>
                {props.children}
            </span>
            <span className={cx('indicator-progress', loading && 'd-inline')}>
                {loadingText ? loadingText : props.children}
            </span>
        </button>
    )
}

export const Link = (props) => {

    const { className, onClick, href, target } = props

    return (
        <a className={className} onClick={onClick} href={href} target={target}>
            {props.children}
        </a>
    )
}